import React from "react";
import { Footprints, Activity, Bone, RefreshCw } from "lucide-react";
import { expertise } from "../mock";
import Reveal from "./Reveal";

const iconMap = { Footprints, Activity, Bone, RefreshCw };

const Expertise = () => {
  return (
    <section id="expertise" className="bg-white">
      <div className="max-w-6xl mx-auto px-4 py-20">
        <Reveal className="text-center mb-14">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold">What I Treat</span>
          <h2 className="font-head text-3xl sm:text-4xl uppercase tracking-wide text-navy mt-2">Areas of Expertise</h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mt-4" />
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {expertise.map((e, i) => {
            const Icon = iconMap[e.icon];
            return (
              <Reveal key={e.title} delay={(i % 4) + 1}>
                <div className="group h-full bg-cream rounded-2xl border border-black/5 p-8 text-center transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl">
                  <div className="w-16 h-16 mx-auto rounded-2xl bg-navy flex items-center justify-center mb-5 transition-all duration-300 group-hover:bg-gold group-hover:rotate-6">
                    <Icon className="w-8 h-8 text-gold transition-colors group-hover:text-navy" />
                  </div>
                  <h3 className="font-head text-lg uppercase tracking-wide text-navy mb-2">{e.title}</h3>
                  <p className="text-sm text-gray-600">{e.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Expertise;
